module.exports = __webpack_public_path__ + "static/scale-model-of-pearland-alliance-for-art-and-culture-in-pearland-texas-5286fb8ec625de7c30bc223919c8a246.png";